import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { RenderFilters } from '../../../elements/render-filters';
import { VehiculosForm } from './vehiculos-form';
import { VehiculosFilter } from './vehiculos-filter';

export const Vehiculos = () => {
    const { open, close } = useDrawer();
    const { get, set } = useStore();
    const navigate = useNavigate();
    
    const filtrosGuardados = get('vehicles-filtroVehiculos') || {};
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>(filtrosGuardados);
    const [query, setQuery] = useState<any>(new URLSearchParams(filtrosGuardados));

    const handleNewAction = () => {
        navigate('/vehicles/create')
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleFilters = () => {
        open('common.filter.title', <VehiculosFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const openInNewTab = (item: any) => {
        window.open(item.photo, '_blank', 'noreferrer');
    };

    const doFilter = (filters: any) => {
        set('vehicles-filtroVehiculos', filters);
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        close();
    };

    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.vehiculos'}
            newActionTitle={'vehiculo.button.new'}
            filterAction={handleFilters}
            filters={filters}
        >
            <>
                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} />
                ) : (
                    ''
                )}
                <Table
                    path="/fleet/vehicles/"
                    deletePath="/fleet/vehicles/"
                    query={query}
                    callBeforeDrawerClosed={handleClose}
                    Form={VehiculosForm}
                    withPagination
                    //onShow={openInNewTab}
                    doEdit={(item: any) => navigate(`/vehicles/${item.id}`)}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'plate',
                            label: 'common.form-label.matricula'
                        },
                        {
                            key: 'brand_name',
                            label: 'common.label.marca'
                        },
                        {
                            key: 'model',
                            subKey: "name",
                            label: 'common.label.modelo'
                        },
                        {
                            key: 'available',
                            type: 'boolean',
                            label: 'common.form-label.disponible',
                        },
                        {
                            key: 'status',
                            type: 'status',
                            label: 'common.label.estado',
                        },
                        {
                            key: 'photo_display_url',
                            type: 'image',
                            label: 'common.form-label.foto',
                        },
                    ]}
                />
            </>
        </PageBody>
    );
};